<template>
  <div>
    <el-input type="input" :placeholder="puPlaceholder" v-model="transferTo" :disabled="inputStatus" clearable suffix-icon="el-icon-search" @click.native="()=>{showDialog=true;queryData()}"></el-input>
    <el-dialog append-to-body :title="title" :visible="showDialog" @close="showDialog = false" width="1000px" class="dialog">
      <div class="table">
        <!--=========查询模块================-->
        <div class="container">
          <div class="handle-box">
            <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
              <el-row :gutter="16">
                <el-col :span="8">
                  <el-form-item :label="$t('sys.userList.userName')" prop="name">
                    <el-input class="handle-input" v-model="queryCondition.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('sys.userList.userCd')" prop="emplid">
                    <el-input class="handle-input" v-model="queryCondition.emplid"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
                  <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
                  <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border highlight-current-row>
            <!-- <el-table-column v-if="puMulti == true" :reserve-selection="true" prop="tmUserId" type="selection" width="55" align="center" /> -->
            <el-table-column width="100" :label="$t('common.select')" prop="name">
              <template slot-scope="scope">
                <el-radio v-model="selectDataAll" @change.native="getSelectRow(scope.row)" :label="scope.row.tmUserId">&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="name" :label="$t('sys.userList.userName')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="emplid" :label="$t('sys.userList.userCd')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="phone" :label="$t('sys.userList.phone')"></el-table-column>
          </el-table>
          <div class="pagination">
            <!--===分页组件===-->
            <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  name: "pickupUser",
  props: {
    inputStatus: Boolean,
    value: String,
    title: String,
    multi: Boolean,
    placeholder: String,
    selectDatas: Array
  },
  data() {
    return {
      selectRow: [],
      puMulti: this.multi,
      puPlaceholder: this.placeholder,
      tableData: [],
      selectedId: this.value,
      selectDataAll: this.multi
        ? {
          defaultData: commonFun.convertToArray(this.value),
          pageDatas: []
        }
        : null,
      totalCount: 0,
      labelPosition: "right",
      queryCondition: { pageSize: 15, pageNum: 1, name: "", emplid: "" },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false,
    };
  },
  create() {
    console.log(this.inputStatus, "禁用状态")
  },
  computed: {
    getSelectedData() {
      // if (this.multi) {
      //   let selectedData = [];
      //   let defaultData = this.selectDataAll.defaultData;
      //   if (commonFun.isNotEmpty(defaultData)) {
      //     selectedData.push(...defaultData);
      //   }
      //   let pageDatas = this.selectDataAll.pageDatas;
      //   for (let pageData of pageDatas.values()) {
      //     if (commonFun.isNotEmpty(pageData)) {
      //       selectedData.push(...pageData);
      //     }
      //   }
      //   return selectedData;
      // } else {
      //   return this.selectDataAll;
      // }
    },
    transferTo() {
      return this.value;
      // if (commonFun.isEmpty(this.getSelectedData)) {
      //   return null;
      // }
      // if (this.puMulti) {
      //   return this.getSelectedData.map(user => user.name).join(";");
      // } else {
      //   return this.selectDataAll.name;
      // }
    }
  },
  watch: {
    value(newVal) {
      console.log(newVal)
      // this.selectDataAll.defaultData = commonFun.convertToArray(newVal);
    }
  },
  methods: {
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = row;
    },
    queryData(val) {
      var that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      userService
        .getUsers(this.queryCondition)
        .then(res => {
          console.log(res)
          this.tableData = res.resultData;
          this.totalCount = res.totalCount;
          this.tableData[1].value = true;
        })
        .then(value => {
          this.$nextTick(() => {
            that.updateCheck();
          });
        });
    },
    pickUp() {
      //   if (this.puMulti) {
      //     this.$emit("input", this.getSelectedData.map(value => value.tmUserId));
      //   } else {
      //     this.$emit("input", this.getSelectedData.tmUserId);
      //   }
      this.$emit("input", this.selectRow.name, this.selectRow.tmUserId);
      this.$emit("pickUp", this.selectRow);
      this.showDialog = false;
    },
    selectionChange(users) {
      let that = this;
      let pageNum = that.queryCondition.pageNum;
      this.$set(
        that.selectDataAll.pageDatas,
        pageNum,
        Array.isArray(users) ? users : [users]
      );
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    editUserInfo(row) {
      this.userInfo = {};
      this.clearVlidate("userInfoForm");
      this.userInfo = row;
      this.showUserInfo = true;
    },
    updateCheck() {
      // if (!this.puMulti) {
      //   if (!commonFun.isEmpty(this.selectDataAll)) {
      //     this.tableData.forEach(row => {
      //       if (row.tmUserId == this.selectDataAll.tmUserId) {
      //         this.selectedId = row.tmUserId;
      //         this.selectDataAll = row;
      //       }
      //     });
      //   }
      // } else {
      //   var that = this;
      //   let defaultData = this.selectDataAll.defaultData;
      //   let existsArr = [];
      //   defaultData.forEach((data, i) => {
      //     if (commonFun.isNotEmpty(data)) {
      //       that.tableData.forEach(row => {
      //         if (row.tmUserId == data.tmUserId) {
      //           that.$refs["pickUserTable"].toggleRowSelection(row, true);
      //           existsArr.push(i);
      //         }
      //       });
      //     }
      //   });
      //   existsArr.forEach(i => {
      //     this.selectDataAll.defaultData.splice(i, 1);
      //   });
      // }
    }
  }
};
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
